import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';
import { CONTEXT_ROOT, FAQ_ID_ELIGIBILITY } from '../../../../constants';

import HeadComponent from '../../../HeadComponent';
import Breadcrumb from '../../../breadcrumb/Breadcrumb';
import LinkButtonComponent from '../../../button/LinkButtonComponent';
import AccountHelpComponent from '../../../authentication/accounthelp/AccountHelpComponent';
import { withTemplate } from '../../../template/withTemplate';
import { PrimaryTemplate } from '../../../template/PrimaryTemplate';

import './NonEligiblePageStyle.scss';

const NonEligiblePage = ({ i18n }) => {
    return (
        <main role="main" className="conteneur conteneur-mobile" id="p-non-eligible">
            <HeadComponent
                title={i18n.TITLE}
                description={i18n.DESCRIPTION}
                canonicalLink={`${CONTEXT_ROOT}${PATH.NON_ELIGIBLE_PATH}`}
            />
            <Breadcrumb
                defaultRoute
                routes={[
                    {
                        label: i18n.BREADCRUMB,
                        route: PATH.NON_ELIGIBLE_PATH
                    }
                ]}
            />

            <h1>{i18n.TITLE}</h1>

            <div className="nonEligible">
                <p className="nonEligible-head">{i18n.HEAD_TEXT}</p>
                <p className="nonEligible-text">{i18n.TEXT}</p>
                <p className="nonEligible-text nonEligible-delay">
                    {i18n.ACTIVATION_DELAY_TEXT}
                </p>
                <div className="nonEligible-action">
                    <LinkButtonComponent
                        color="fourth"
                        to={`${PATH.FAQ_PATH}#${FAQ_ID_ELIGIBILITY}`}
                        title={i18n.BUTTON}
                        text={i18n.BUTTON}
                    />
                </div>
                <AccountHelpComponent />
            </div>
        </main>
    );
};

const mapStateToProps = state => ({
    i18n: state.i18n.page.NON_ELIGIBLE
});

export default withTemplate(connect(mapStateToProps)(NonEligiblePage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/authentication/non-eligible/NonEligiblePage.js